import { render, staticRenderFns } from "./viewFeeData.vue?vue&type=template&id=8c2384da"
import script from "./viewFeeData.vue?vue&type=script&lang=js"
export * from "./viewFeeData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports